import customLevelHeaderLogoMap from "./customLevelHeaderLogoMap"

export default function getCustomLevelHeaderLogo(brand) {
  return customLevelHeaderLogoMap[brand]?.logo || null
}